import React from 'react';
import './GradientText.css';

const GradientText = ({
  children,
  className = '',
  colors = ['#60a5fa', '#3b82f6', '#60a5fa', '#93c5fd', '#60a5fa'],
  animationSpeed = 8,
  showBorder = false
}) => {
  const gradientStyle = {
    backgroundImage: `linear-gradient(to right, ${colors.join(', ')})`,
    animationDuration: `${animationSpeed}s`
  };

  return (
    <div className={`animated-gradient-text ${className}`}>
      {showBorder && <div className="gradient-overlay" style={gradientStyle}></div>}
      <div className="text-content" style={gradientStyle}>
        {children}
      </div>
    </div>
  );
};

export default GradientText;


